import React from "react";

/** Loader de marque NelDaari : le logo « N » (carré rouge arrondi) qui pulse,
 * à la manière du « P » de PayPal — utilisé pendant la connexion et les
 * chargements de pages protégées. */
export const BrandLoader = ({ message = "Chargement…", fullScreen = false }) => (
  <div
    data-testid="brand-loader"
    className={`grid place-items-center ${fullScreen ? "fixed inset-0 z-[100] bg-white/95 backdrop-blur-sm" : "min-h-[50vh]"}`}
  >
    <div className="text-center">
      <div className="relative w-20 h-20 mx-auto mb-4">
        {/* Halo qui s'étend derrière le logo */}
        <div className="absolute inset-0 rounded-2xl bg-brand-red/30 brand-loader-halo" />
        {/* Logo NelDaari */}
        <img
          src="/logo-neldaari.png"
          alt="NelDaari"
          className="relative w-20 h-20 brand-loader-pulse"
          style={{ filter: "drop-shadow(0 10px 25px rgba(227,38,54,.3))" }}
        />
      </div>
      <div className="font-display text-lg font-semibold tracking-wide">NelDaari</div>
      <p className="text-mute text-sm mt-1">{message}</p>
    </div>
  </div>
);

export default BrandLoader;
